// Services.js
import React from 'react'
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import '../style/style.css'
import { useNavigate } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';

function Services() {
  const link = require('../img/href.png');
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <section className='ServicesFirstWrapper'>
        <div className='ServicesFirst'>
          <p className='SmHeading SHeaderName'>
            SERVICES
          </p>
          <p className='Motto SHeaderMotto'>
            WHAT WE<br/> BUILD FOR YOU
          </p>
          <p className='SmTxt SHeaderSmTxt'>
            Three disciplines. One studio. Infinite possibilities.
          </p>
        </div>
      </section>
      <section className='ServicePart'>
        <div className='SPUltraWrapper' id='WebDesign'>
          <p className='Numeric'>
            (01)
          </p>
          <div className='SPWrapper'>
            <div className='SPHeaderWrapper'>
              <p className='BigHeading SPHeader'>
                WEB DESIGN &<br/>
                DEVELOPMENT
              </p>
              <a href='#'>
                <img src={link} className='HrefArrow'/>
              </a>
            </div>
            <p className='MiddleTxt'>
              Custom websites and web apps built for performance, beauty, and measurable results.
            </p>
            <div className='SmWrapper'>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  STRATEGY
                </p>
                <p className = 'SPBTxt'>
                  Discovery & Research
                </p>
                <p className = 'SPBTxt'>
                  UX Architecture
                </p>
                <p className = 'SPBTxt'>
                  Information Design
                </p>
                <p className = 'SPBTxt'>
                  Conversion Strategy
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  DESIGN
                </p>
                <p className = 'SPBTxt'>
                  UI/UX Design
                </p>
                <p className = 'SPBTxt'>
                  Design Systems
                </p>
                <p className = 'SPBTxt'>
                  Motion & Micro-interactions
                </p>
                <p className = 'SPBTxt'>
                  Responsive Layouts
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  DEVELOPMENT
                </p>
                <p className = 'SPBTxt'>
                  React / Next.js
                </p>
                <p className = 'SPBTxt'>
                  Headless CMS
                </p>
                <p className = 'SPBTxt'>
                  Performance Optimisation
                </p>
                <p className = 'SPBTxt'>
                  SEO Architecture
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
{/*      <section className='ServicePart'>
        <div className='SPUltraWrapper' id='3dModelling'>
          <p className='Numeric'>
            (02)
          </p>
          <div className='SPWrapper'>
            <div className='SPHeaderWrapper'>
              <p className='BigHeading SPHeader'>
                3D MODELLING<br/>
                & ANIMATION
              </p>
              <a href='#'>
                <img src={link} className='HrefArrow'/>
              </a>
            </div>
            <p className='MiddleTxt'>
              Photorealistic 3D assets and animations that stop audiences and sell products.
            </p>
            <div className='SmWrapper'>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  MODELLING
                </p>
                <p className = 'SPBTxt'>
                  Product Visualisation
                </p>
                <p className = 'SPBTxt'>
                  Hard-surface Modelling
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  ANIMATION
                </p>
                <p className = 'SPBTxt'>
                  Motion Graphics
                </p>
                <p className = 'SPBTxt'>
                  Product Animation
                </p>  
                <p className = 'SPBTxt'>
                  Cinematic Sequences
                </p>
                <p className = 'SPBTxt'>
                  Loop Animation
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  INTEGRATION
                </p>
                <p className = 'SPBTxt'>
                  AR-Ready Assets
                </p>
                <p className = 'SPBTxt'>
                  Scene Composition
                </p>
                <p className = 'SPBTxt'>
                  Format Delivery
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className='ServicePart'>
        <div className='SPUltraWrapper' id='AI'>
          <p className='Numeric'>
            (02)
          </p>
          <div className='SPWrapper'>
            <div className='SPHeaderWrapper'>
              <p className='BigHeading SPHeader'>
                AI-GENERATED<br/>
                CONTENT
              </p>
              <a href='#'>
                <img src={link} className='HrefArrow'/>
              </a>
            </div>
            <p className='MiddleTxt'>
              Harness generative AI for photo-real visuals and video — art-directed by our creative team.
            </p>
            <div className='SmWrapper'>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  IMAGES
                </p>
                <p className = 'SPBTxt'>
                  Campaign Visuals
                </p>
                <p className = 'SPBTxt'>
                  Product Photography
                </p>
                <p className = 'SPBTxt'>
                  Lifestyle Imagery
                </p>
                <p className = 'SPBTxt'>
                  Brand-consistent AI Art
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  VIDEO
                </p>
                <p className = 'SPBTxt'>
                  AI Video Production
                </p>
                <p className = 'SPBTxt'>
                  Motion Templates
                </p>  
                <p className = 'SPBTxt'>
                  Brand Films
                </p>
                <p className = 'SPBTxt'>
                  Social Content Packs
                </p>
              </div>
              <div className='SPBlock'>
                <p className='SPBHeader'>
                  SCALE & QUALITY
                </p>
                <p className = 'SPBTxt'>
                  Prompt Engineering
                </p>
                <p className = 'SPBTxt'>
                  Model Fine-tuning
                </p>
                <p className = 'SPBTxt'>
                  Batch Production
                </p>
                <p className = 'SPBTxt'>
                  Art Direction
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='RTS'>
        <p className='BigTxt'>
          READY TO START A PROJECT?
        </p>
        <button className='ContactBtn' onClick={() => navigate("/contact")}>
          Let's Talk →
        </button>
      </section> 
      <Footer/>
    </div>
  )
}

export default Services
